import { hasContactSourceType } from 'domains/models/event_source/sourceType';
import { getDateTime } from 'infras/datetime';
import { EventListItem } from 'presentations/api/schema/event';
import { dashboardGuestEventPath, dashboardHostEventPath } from '.';

export const eventDetailPath = (
  event: EventListItem,
  asPath: string,
  userId?: string,
) => {
  if (hasContactSourceType(event.sourceType) && !event.isHost) {
    return dashboardGuestEventPath(event.uid, {
      from: asPath,
      userId,
    });
  } else {
    return dashboardHostEventPath(event.uid, {
      from: asPath,
      userId: userId,
      startedAt: getDateTime(event.startedAt).toMillis(),
      endedAt: getDateTime(event.endedAt).toMillis(),
    });
  }
};
